import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Grid, Box, Paper, createStyles,makeStyles } from '@material-ui/core';
import { TextBlock, Link } from 'neon-design-system';
import { useParams } from 'react-router-dom';
import { GET_CHARTS_ARTICLES } from '../../../gql/articles';
import { CHARTS_LOGO } from '../../../config';
import { getArticleLink } from '../../../utils/link.utils';

const useStyles = makeStyles(theme => createStyles({
	chartArticleCard: {
		width: '100%',
		height: '100%',
		padding: theme.spacing(3)
	},
	articleLink: {
		...theme.typography.h5,
		color: theme.palette.grey[200],
		'&:hover': {
			color: theme.palette.primary.contrastText
		},
		[theme.breakpoints.up('md')]: {
			...theme.typography.h4
		}
	},
	articleSummary: {
		[theme.breakpoints.down('sm')]: {
			display: 'none'
		}
	}
}));

interface ChartArticleCardInterface {
	_id: string;
	title: string;
	summary: string;
}

const ChartArticleCard = (props: ChartArticleCardInterface) => {
	const classes = useStyles();
	const { _id, title, summary } = props;

	const articleLink = getArticleLink(_id);

	return (
		<Paper className={classes.chartArticleCard}>
			<Box mb={1}><img src={CHARTS_LOGO} alt="chart-logo" /></Box>
			<Box mb={1}>
				<Link to={articleLink} className={classes.articleLink}>{title}</Link>
			</Box>
			<Box className={classes.articleSummary}>
				<TextBlock ink="muted">{summary}</TextBlock>
			</Box>
		</Paper>
	)
}

const ChannelChartsArticles: React.FC = () => {
	const { channelId } = useParams<{ channelId: string }>();

	const { data } = useQuery(GET_CHARTS_ARTICLES, {
		variables: { premiumChannelId: channelId },
		fetchPolicy: 'network-only'
	});

	const chartArticles = data?.getChartsArticles || [];

	return chartArticles.length ? (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextBlock styleName="largeBody1">Charts</TextBlock>
			</Grid>
			<Grid item xs={12}>
				<Grid container spacing={2}>
					{chartArticles.map((ca: ChartArticleCardInterface, key: number) => (
						<Grid item xs={6} md={4} key={key}>
							<ChartArticleCard
								_id={ca._id}
								title={ca.title}
								summary={ca.summary}
							/>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Grid>
	) : <></>;
};

export default ChannelChartsArticles;
